import { render, staticRenderFns } from "./PMProject.vue?vue&type=template&id=00d6c0dd&"
import script from "./PMProject.vue?vue&type=script&lang=ts&"
export * from "./PMProject.vue?vue&type=script&lang=ts&"
import style0 from "./PMProject.vue?vue&type=style&index=0&id=00d6c0dd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports